import * as React from "react";
import { Alert, Avatar, Button, Input, Tag, Tooltip } from "antd";
import { SendOutlined, LeftOutlined, CloseOutlined } from "@ant-design/icons";
import scrollIntoView from "scroll-into-view-if-needed";
import "./Styles/Chat.scss";
import Loader from "./Loader";
import dayjs from "dayjs";
import utils from "utils";
import { connect } from "react-redux";
import consultationSlice from "store/slice/consultation-slice";
import { Client as ConversationsClient } from "@twilio/conversations";
import { ReloadOutlined } from "@ant-design/icons";
import { Col, Row, message } from "antd";
import api from "utils/api";
import { LoadingOutlined } from "@ant-design/icons";
import { CONSTANTS } from "utils/constant";
import { CHAT_SER_NOT_AVAIL_MSG } from "Common/constant";
import { SUCCESS_CODE } from "Common/constant";

class PatientConversation extends React.Component {
  client = null;
  constructor(props) {
    super(props);
    this.state = {
      text: "",
      messages: [],
      channel: null,
      roomName: "",
      token: "",
      isLoading: false,
      isConvoReady: false,
      user: this.props.user || {},
      isChannelRemoved: true,
      user_details: this.props.user_details,
      conversation: null,
      patient_token: null,
      care_admin_identity: 0,
      isConvoInitd: false,
      tokenExpired: false,
      patient_name: null,
      care_admin_name: null,
      care_admin_last_name: null,
      is_conversation_applicable: true,
      super_ca_mobile: null,
      super_ca_email: null,
      waitingMsg: null,
      showAlert: false,
      chatConnFailed: false,
      // chat_data:
      //   this.props.user_details.role == "patient"
      //     ? this.props.chat_data.token_details
      //     : Object.assign({}, this.props.chat_data.results[0]),
    };
  }

  scrollToMessageBottom() {
    if (
      document.getElementById(
        `message-list-item-${this.state.messages?.length - 1}`
      )
    ) {
      scrollIntoView(
        document.getElementById(
          `message-list-item-${this.state.messages?.length - 1}`
        ),
        {
          behavior: "instant",
          scrollMode: "if-needed",
          // boundary: document.getElementById("message-container"),
        }
      );
    }
  }

  addMessages = (message) => {
    const { messages } = this.state;
    let msg =
      Array.isArray(message) && message.length
        ? message
        : !Array.isArray(message) && typeof message == "object"
        ? [message]
        : [];
    this.setState(
      {
        messages: [...messages, ...msg],
      },
      () => {
        if (this.state.messages?.length > 0) {
          this.scrollToMessageBottom();
        }
      }
    );
  };

  sendMessage = () => {
    const { strValue, conversation } = this.state;

    if (strValue && String(strValue).trim()) {
      this.setState({ loading: true });
      conversation.sendMessage(strValue);
      this.setState({ strValue: "", loading: false });
    }
  };

  getPatientChatTokenDetails() {
    this.setState({ isLoading: true });
    this.props.updateChatInit(true);
    api
      .patient_chat_token_details()
      .then((res) => {
        let { data = {}, status } = res.data;
        this.props.updateChatInit(false);
        if (status == SUCCESS_CODE) {
          if (data?.is_conversation_applicable) {
            let {
              patient_token,
              patient_identity,
              room_id,
              chat_id,
              patient_name,
              care_super_admin_email,
              care_super_admin_mobile,
              // care_admin_name,
            } = data || {};

            this.setState({
              patient_token,
              patient_identity,
              room_id,
              chat_id,
              patient_name,
              isLoading: false,
              // care_admin_name,
              super_ca_mobile: care_super_admin_mobile,
              super_ca_email: care_super_admin_email,
            });
            this.props.updateChatId(chat_id);
            this.initConversation();
          } else {
            let msg = `Chat available between 10AM to 6PM(IST). Please reach out to our Care admin at ${data.care_super_admin_mobile} or reach mail at ${data.care_super_admin_email}`;
            this.setState({
              is_conversation_applicable: false,
              isLoading: false,
              super_ca_mobile: data?.super_ca_email,
              super_ca_email: data?.super_ca_email,
              waitingMsg: msg,
            });
          }
        } else {
          this.setState({
            is_conversation_applicable: false,
            isLoading: false,
            waitingMsg: CHAT_SER_NOT_AVAIL_MSG,
          });
        }
      })
      .catch((err) => {
        this.props.updateChatInit(false);
      });
    // .finally(() => {
    //   this.setState({
    //     isLoading: false,
    //   });
    // });
  }

  handleConvoUpdate(details) {
    if (details?.updateReasons.includes("attributes")) {
      this.state.conversation.getParticipants().then((participants) => {
        if (participants.length == 1) {
          // let careadmin_id =
          //   this.props.chatDetails?.care_admin_identity.toString();
          let careadmin_id = details?.conversation?.attributes?.care_admin_id;
          let care_admin_name =
            details?.conversation?.attributes?.care_admin_name;
          let care_admin_last_name =
            details?.conversation?.attributes?.care_admin_last_name;
          this.state.conversation
            .add(careadmin_id)
            .then((res) => {
              let data = {
                care_admin_identity: careadmin_id,
                chat_id: this.state.chat_id || this.props.chatDetails?.chat_id,
                is_participant_added: true,
              };

              api
                .confirm_participant(data)
                .then((res) => {})
                .catch((error) => {});

              this.setState({
                care_admin_identity: careadmin_id,
                care_admin_name: care_admin_name,
                care_admin_last_name: care_admin_last_name,
                isConvoReady: true,
                showAlert: true,
                waitingMsg: null,
              });
              this.props.updateCareAdminName(care_admin_name);
            })
            .catch((error) => {});
        }
      });
    } else if (details?.updateReasons.includes("state")) {
      if (details?.conversation?.state?.current == "closed") {
        this.conversationsClient.removeAllListeners();
        this.conversationsClient.on("tokenExpired", (m) =>
          this.handleTokenExpire(m)
        );
        this.props.updateChatClose();
        this.setState({ isChatClosed: true });
        if (document.getElementById("chat-closed")) {
          scrollIntoView(document.getElementById("chat-closed"), {
            behavior: "instant",
            scrollMode: "if-needed",
          });
        }
      }
      if (details?.conversation?.state?.current == "inactive") {
        let msg = this.state.care_admin_name
          ? "This chat session has expired. Please open a new chat session"
          : `We are unable to connect you with our care admin on ${this.props.label_color_theme} Live Chat. Please reach out to our Care admin at ${this.state.super_ca_mobile} or reach mail at ${this.state.super_ca_email}`;
        this.setState({
          isConvoReady: false,
          // convoInactive: true,
          waitingMsg: msg,
        });
      }
    }
  }

  loadMessagesFor = (thisConversation) => {
    thisConversation
      .getMessages()
      .then((messagePaginator) => {
        this.setState({
          messages: messagePaginator.items,
          loadingState: "ready",
        });
        this.scrollToMessageBottom();
      })
      .catch((err) => {
        console.error("Couldn't fetch messages IMPLEMENT RETRY", err);
        this.setState({ loadingState: "failed" });
      });
  };

  handleConversationCreate = (conversationsClient) => {
    const convo_name = this.state.room_id || this.props.chatDetails?.room_id;
    conversationsClient
      .createConversation({
        uniqueName: convo_name,
        friendlyName: convo_name,
      })
      .then((convo) => {
        convo.join().then((res) => {
          this.props.updateChatInit(false);
          this.setState({
            conversation: convo,
            isConvoReady: true,
            waitingMsg: " Please wait for the Care Admin to join.",
          });
          //event listeners
          convo.on("messageAdded", (m) => this.addMessages(m));
          convo.on("updated", (m) => this.handleConvoUpdate(m));
          // convo.on("participantLeft", (m) => this.handleChatStateClose(m));
          api
            .update_conversation_attributes({
              chat_id: this.state.chat_id,
              is_chat_created: true,
            })
            .then((res) => {})
            .catch((error) => {});
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ waitingMsg: null, chatConnFailed: true });
        this.props.updateChatInit(false);
        api
          .update_conversation_attributes({
            chat_id: this.state.chat_id,
            is_chat_created: false,
          })
          .then((res) => {})
          .catch((error) => {});
        this.props.closeChat();
      });
  };

  componentWillUnmount() {
    if (this.state.is_conversation_applicable && this.conversationsClient) {
      this.conversationsClient.shutdown();
      window.removeEventListener("beforeunload", this.handleCleanup);
      if (this.state.conversation) {
        this.state.conversation.removeAllListeners();
      }
      if (this.props.isLiveChatOpen) {
        this.props.clearChatDetails();
      }
    }
  }

  handleConvoJoin(conversationsClient) {
    // this.conversationsClient.on("conversationJoined", (conversation) => {
    //   if (conversation?.uniqueName == convo_name) {
    //     // this.loadMessagesFor(conversation);
    //   }
    // });
    const convo_name = this.state.room_id || this.props.chatDetails?.room_id;

    if (this.props.isLiveChatOpen) {
      conversationsClient
        .getConversationByUniqueName(convo_name)
        .then((convo) => {
          //event listeners
          convo.on("messageAdded", (m) => this.addMessages(m));
          convo.on("updated", (m) => this.handleConvoUpdate(m));
          // convo.on("participantLeft", (m) => this.handleChatStateClose(m));
          this.props.updateChatInit(false);
          this.setState({
            conversation: convo,
            isConvoReady: true,
            waitingMsg: null,
          });
          this.loadMessagesFor(convo);
          convo
            .getParticipants()
            .then((participants) => {
              if (participants.length == 1) {
                this.setState({
                  waitingMsg: "Please wait for the Care Admin to join.",
                });
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch((error) => {
          this.handleConversationCreate(conversationsClient);
        });
    } else {
      this.handleConversationCreate(conversationsClient);
    }
    // this.conversationsClient.on("conversationLeft", (thisConversation) => {
    //   console.log(thisConversation);
    // });
  }

  initConversation = async () => {
    // this.setState({
    //   isConvoReady: false,
    // });
    this.props.updateChatInit(true);
    this.setState({
      waitingMsg: "Please wait while we connect you to the Care Admin...",
    });
    this.conversationsClient = new ConversationsClient(
      this.props.chatDetails?.patient_token || this.state.patient_token
    );

    this.conversationsClient.on("initialized", () => {
      this.handleConvoJoin(this.conversationsClient);
    });

    // this.conversationsClient.on("messageAdded", (m) => this.addMessages(m));

    this.conversationsClient.on("tokenAboutToExpire", (m) =>
      this.getUpdatedChatToken(m)
    );

    this.conversationsClient.on("tokenExpired", (m) =>
      this.handleTokenExpire(m)
    );

    this.conversationsClient.on("initFailed", ({ error }) => {
      console.log("Convo Init Failed", error);
      this.props.updateChatInit(false);
      this.setState({ waitingMsg: null, chatConnFailed: true });
      api
        .update_conversation_attributes({
          chat_id: this.state.chat_id,
          is_chat_created: false,
        })
        .then((res) => {})
        .catch((error) => {});
      this.conversationsClient.removeAllListeners();
      this.props.closeChat();
    });
  };

  displayWaitingMsg() {
    let count = 1,
      flag = false;

    let timer = setInterval(() => {
      const { channel } = this.state;
      if (this.state.isMemberJoined) {
        const { uniqueName, friendlyName, createdBy } =
          channel.channelState || {};
        // console.log(channel)
        channel.sendMessage(
          `Hi ${
            (createdBy != this.state.user?.user_id &&
              utils.FormatName(utils.getDisplayName(friendlyName))) ||
            "there"
          }! How can we help you today?`
        );
        clearInterval(timer);
        return 0;
      }
      // if (!this.state.isMemberJoined && count % 60 == 0 && this.state.messages?.length < 4) {
      //     this.setState(state => ({
      //         messages: [...state.messages, { state: { body: `All of our support team members are ${flag ? "still " : ""}busy. Please hold on or try again after sometime.` } }]
      //     }))
      //     flag = true;
      // }
      // count++
    }, 1000);
  }

  // closeChannel() {
  //   let timer = setInterval(() => {
  //     const { channel } = this.state;
  //     const { dateCreated } = channel?.channelState?.lastMessage || {};
  //     if (
  //       dateCreated &&
  //       dayjs().isAfter(dayjs(dateCreated).add(15, "minutes"))
  //     ) {
  //       this.state.channel.delete().then((channel) => {
  //         typeof this.props.onCloseChannel == "function" &&
  //           this.props.onCloseChannel(this.state.chat_id);
  //       });
  //       clearInterval(timer);
  //     }
  //   }, 1000);
  // }

  // handleReload() {
  //   this.setState({
  //     isLoading: true,
  //   });

  //   api
  //     .get_patient_chat_status()
  //     .then((res) => {
  //       let { data = {}, is_care_admin_available } = res.data;

  //       let {
  //         patient_token,
  //         patient_identity,
  //         room_id,
  //         chat_id,
  //         care_admin_identity,
  //       } = data || {};

  //       this.setState({
  //         patient_token,
  //         patient_identity,
  //         room_id,
  //         chat_id,
  //         care_admin_identity,
  //       });

  //       this.state.conversation
  //         .add(care_admin_identity.toString())
  //         .then((participants) => {})
  //         .catch((error) => {
  //           console.log("Unable to add participant");
  //         });
  //     })
  //     .finally(() => {
  //       this.setState({
  //         isLoading: false,
  //       });
  //     });
  // }

  getUpdatedChatToken() {
    let data = {
      chat_id: this.state.chat_id,
    };
    // console.log("Update chat token block");
    api
      .get_chat_updated_token(data)
      .then((res) => {
        let { data } = res.data;
        // console.log(data);
        this.conversationsClient.updateToken(data?.patient_token);
      })
      .catch((error) => {
        console.log("Unable to update token");
      });
  }

  handleTokenExpire(detail) {
    message.warning("Chat session expired", ErrorDuration);
    this.props.closeChat();
  }

  handleCleanup() {
    if (this.state.conversation) {
      // this.state.conversation.update({ state: "closed" });
      this.state.conversation.removeAllListeners();
      this.conversationsClient.shutdown();
    }
  }

  componentDidMount = () => {
    window.addEventListener("beforeunload", this.handleCleanup);
    if (this.props.isLiveChatOpen) {
      this.setState({
        patient_token: this.props.chatDetails?.patient_token,
        patient_identity: this.props.chatDetails?.patient_identity,
        room_id: this.props.chatDetails?.room_id,
        chat_id: this.props.chatDetails?.chat_id,
        care_admin_identity: this.props.chatDetails?.care_admin_identity,
        patient_name: this.props.chatDetails?.patient_name,
        care_admin_name: this.props.chatDetails?.care_admin_name,
        care_admin_last_name: this.props.chatDetails?.care_admin_last_name,
        super_ca_mobile: this.props.chatDetails?.care_super_admin_mobile,
        super_ca_email: this.props.chatDetails?.care_super_admin_email,
      });
      this.props.updateChatId(this.props.chatDetails?.chat_id);
      this.initConversation();
    } else {
      this.getPatientChatTokenDetails();
    }
  };

  shouldComponentUpdate(nextProps, nextState) {
    if (this.state != nextState) return true;
    else if (nextProps.room_id == this.props.room_id) return false;
    return true;
  }

  renderFooter() {
    // if(this.state.isChannelRemoved && this.state.user?.role == "care_admin" && !this.state.isMemberJoined) {
    //     return <div className='waiting-message'>You are not allowed to send messages in this chat. Wait for the user to join.</div>
    // console.log(this.state.user.role, this.state.channel)
    // }
    // if (this.state?.user?.role == "patient") {
    return (
      // <Input.Group compact>
      //   <Input
      //     className="send-message-icon"
      //     addonAfter={
      //       <SendOutlined
      //         onClick={this.sendMessage}
      //         className="send-message-icon"
      //       />
      //     }
      //     placeholder="Type a new message"
      //     value={this.state.strValue || null}
      //     onChange={(event) =>
      //       this.setState({ strValue: event.target.value })
      //     }
      //     onPressEnter={this.sendMessage}
      //   />
      // </Input.Group>
      <Input.Search
        autoFocus
        placeholder="Type a new message"
        value={this.state.strValue || null}
        // disabled={this.state.isLoading}
        onChange={(event) => this.setState({ strValue: event.target.value })}
        onPressEnter={this.sendMessage}
        enterButton={<SendOutlined />}
        onSearch={this.sendMessage}
        style={{
          width: "100%",
        }}
      />
    );
    // }
    // return null;
  }

  render() {
    const { showHeader, style } = this.props;

    return (
      <div className="chat-container patient-chat-container">
        <div className="chat-wrapper patient-chat-wrapper">
          {/* <div
            className={`chat-header ${showHeader == false ? " hide" : " show"}`}
          >
            Chat
          </div> */}
          <div
            className="message-container"
            id="message-container"
            // style={style || {}}
          >
            {this.state.isLoading && <Loader />}
            {this.state.waitingMsg && (
              <Row className="waiting-msg-patient-chat" align="middle">
                <Col span={24}>
                  <div className="waiting-message waiting-msg-chat">
                    {this.state.waitingMsg}
                  </div>
                </Col>
              </Row>
            )}

            {this.state.care_admin_name &&
              this.state.isConvoReady &&
              this.state.showAlert && (
                <Row
                  className="waiting-msg-patient-chat faq-list-item"
                  align="middle"
                >
                  <Col span={22}>
                    <div className="waiting-message waiting-msg-chat">
                      {`You are connected with ${utils.FormatName(
                        utils.getDisplayName(
                          this.state.care_admin_name,
                          this.state.care_admin_last_name
                        )
                      )}`}
                    </div>
                  </Col>
                  <Col span={2}>
                    <CloseOutlined
                      onClick={() => this.setState({ showAlert: false })}
                    />
                  </Col>
                </Row>
              )}
            {this.state.messages.map((obj, i) => {
              let { state: message } = obj || {};

              return (
                <div
                  key={i}
                  id={`message-list-item-${i}`}
                  className="chatdetail-container"
                  // className={
                  //   message?.author == this.state.patient_identity?.toString()
                  //     ? "local-user"
                  //     : "remote-user"
                  // }
                >
                  {/* {message?.author == this.state.patient_identity ? (
                    ""
                  ) : (
                    <Avatar className="avatar">
                      {message?.author ==
                      this.state.patient_identity?.toString()
                        ? ""
                        : //  utils.FormatName(this.state?.patient_name.charAt(0))
                          utils.FormatName(
                            this.state?.care_admin_name.charAt(0)
                          )}
                    </Avatar>
                  )} */}
                  <div
                    // className="user-message"
                    className={
                      message?.author == this.state.patient_identity?.toString()
                        ? "question-txt-grid-item "
                        : "answer-txt-grid-item"
                    }
                  >
                    <div
                      className={
                        message?.author ==
                        this.state.patient_identity?.toString()
                          ? "question-txt mt-12"
                          : "answer-txt mt-12"
                      }
                    >
                      {message?.body}
                    </div>
                  </div>
                </div>
              );
            })}
            {this.state.chatConnFailed && (
              <div id="chat-closed" className="chat-closed-msg">
                {CONSTANTS.CHAT_CONNECT_FAILED_MSG}
              </div>
            )}
            {this.state.isChatClosed && (
              <div id="chat-closed" className="chat-closed-msg">
                {CONSTANTS.CHAT_CLOSED_MSG}
              </div>
            )}
          </div>
        </div>
        {this.state.isConvoReady &&
          !this.state.isChatClosed &&
          this.state.care_admin_identity != 0 && (
            <div className="chat-footer-AI">
              <Input.Search
                className="chat-input-search"
                autoFocus
                placeholder="Type a new message"
                value={this.state.strValue || null}
                // disabled={this.state.isLoading}
                onChange={(event) =>
                  this.setState({ strValue: event.target.value })
                }
                onPressEnter={this.sendMessage}
                enterButton={<SendOutlined />}
                onSearch={this.sendMessage}
              />
            </div>
          )}
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    user_details: state.loginReducer.user_details,
    label_color_theme: state.dashboardReducer.label_color_theme
  };
};
export default connect(mapStateToProps)(PatientConversation);
